import { QueryClient } from '@tanstack/react-query';
import { LIST_ITEMS_COUNT } from '@/constants/lists.constants';
import { ocsConsoleQueries } from '@/queries/ocs-consoles';

export const ocsConsolesLoader = (queryClient: QueryClient) => () => {
  return queryClient.ensureQueryData(ocsConsoleQueries.list({ itemsPerPage: LIST_ITEMS_COUNT, pageIndex: 0 }));
};

export const ocsConsolesByIdLoader = (queryClient: QueryClient) => (consoleId: string) => {
  return queryClient.fetchQuery({
    ...ocsConsoleQueries.item(consoleId),
  });
};
